"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.list.title': 'Ramas de Profesión',
    'branch.list.empty': 'No se encontraron ramas',
};
